import { Contracts } from '../../types';
import { Pagination } from '@infrastructure/axios/types';
import BackendResponse from '@core/shared/backend-response';
import { HttpGetRequest } from '@infrastructure/axios/http-get-request';

export interface IGetAllContractUseCase {
  execute(page: Pagination): Promise<BackendResponse<Contracts[]>>;
}
export default class GetAllContractUseCase extends HttpGetRequest<Contracts[]> implements IGetAllContractUseCase {
  async execute(page: Pagination): Promise<BackendResponse<Contracts[]>> {
    const url = this.buildURL('/contracts', page).get();
    return (await this.dispatch(url)).data;
  }
}
